(function () {
    "use strict";

    angular.module("app").factory("whatsNewApi", WhatsNewApiFactory);

    WhatsNewApiFactory.$inject = [
        "apiClientFactory",
    ];
    function WhatsNewApiFactory(
        apiClientFactory,
    ) {
        const routePrefix = "api/whatsnew/";

        return {
            Get: (successCallback, errorCallback, finallyCallback) => apiClientFactory.get(`${routePrefix}`)(undefined, successCallback, errorCallback, finallyCallback),
            GetHistory: (successCallback, errorCallback, finallyCallback) => apiClientFactory.get(`${routePrefix}history`)(undefined, successCallback, errorCallback, finallyCallback),
            GetHistorySince: (publishedSince) => (successCallback, errorCallback, finallyCallback) => apiClientFactory.get(`${routePrefix}history?published_since=${publishedSince}`)(undefined, successCallback, errorCallback, finallyCallback),
            GetLastSeenOn: (successCallback, errorCallback, finallyCallback) => apiClientFactory.get(`${routePrefix}last-seen-on`)(undefined, successCallback, errorCallback, finallyCallback),
            UpdateLastSeenOn: apiClientFactory.post(`${routePrefix}last-seen-on`),
        };
    }
})();